import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { getEzdParametersAPI, updateEzdParametersAPI } from "./endpoints";

function* getEzdParametersSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getEzdParametersAPI, action.payload);
    yield put(actions.setEzdParameters(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* updateEzdParametersSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(updateEzdParametersAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.getEzdParameters());
      yield put(
        commonActions.setAlert({
          message: "EZD Parameters Updated Successfully",
          alertType: "success",
          showToast: true,
        })
      );
    }
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || "Update EZD Parameters is Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

export function* withEZDParametersSaga() {
  yield all([
    takeEvery(actionTypes.GET_EZD_PARAMETERS, getEzdParametersSaga),
    takeEvery(actionTypes.UPDATE_EZD_PARAMETERS, updateEzdParametersSaga)
  ]);
}
